module.exports = __webpack_public_path__ + "static/media/polynesian_canoe_herb_cane.7a584880.jpg";